import { render, staticRenderFns } from "./AccessApi.vue?vue&type=template&id=ba72c110&"
import script from "./AccessApi.vue?vue&type=script&lang=js&"
export * from "./AccessApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports